import { useCallback, useEffect } from 'react'
import { useSocket } from './useSocket.hook'

export const useSocketIoListener = (eventName: string, handler: (event: any) => void) => {
  const socket = useSocket()

  // Memoize the handler to prevent unnecessary re-renders
  const memoizedHandler = useCallback(handler, [handler])

  useEffect(() => {
    if (!socket) return

    socket.on(eventName, memoizedHandler)

    return () => {
      socket.off(eventName, memoizedHandler)
    }
  }, [eventName, socket, memoizedHandler])

  return socket
}
